/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var TraceabilityEntity;
(function (TraceabilityEntity) {
    var integration;
    (function (integration) {
        integration["INFRASTRUCTURE"] = "INFRASTRUCTURE";
        integration["KNOLL_EXTRACT"] = "KNOLL_EXTRACT";
        integration["CSP_EXTRACT"] = "CSP_EXTRACT";
        integration["PRODUCT_INGEST"] = "PRODUCT_INGEST";
        integration["STAGING_DELETE"] = "STAGING_DELETE";
        integration["PRICE_INGEST"] = "PRICE_INGEST";
        integration["ENGINEERING_REINGEST"] = "ENGINEERING_REINGEST";
        integration["API"] = "API";
        integration["M2M_INTEGRATION"] = "M2M_INTEGRATION";
        integration["INTEGRATION_TEST"] = "INTEGRATION_TEST";
        integration["OPENSEARCH"] = "OPENSEARCH";
        integration["CSP_INITIAL_LOAD"] = "CSP_INITIAL_LOAD";
        integration["HISTORICAL_PARSED_RESULTS"] = "HISTORICAL_PARSED_RESULTS";
        integration["CSP_RESTART"] = "CSP_RESTART";
        integration["MASS_VALIDATION"] = "MASS_VALIDATION";
        integration["CATALOG_EXTRACT"] = "CATALOG_EXTRACT";
        integration["CPQ_EXTRACT"] = "CPQ_EXTRACT";
        integration["GEIGER_INTEGRATION"] = "GEIGER_INTEGRATION";
        integration["DATA_LAKE_EXTRACT"] = "DATA_LAKE_EXTRACT";
    })(integration = TraceabilityEntity.integration || (TraceabilityEntity.integration = {}));
    var status;
    (function (status) {
        status["SUCCESS"] = "SUCCESS";
        status["WARNING"] = "WARNING";
        status["ERROR"] = "ERROR";
    })(status = TraceabilityEntity.status || (TraceabilityEntity.status = {}));
})(TraceabilityEntity || (TraceabilityEntity = {}));
